import React, { Component } from "react";
import Header from "./components/Header/Header";
import "./App.css";
import { Route, Switch } from "react-router-dom";
import IBKompletni from "./components/IBKompletni/IBKompletni";
import axios from "axios";
import Modal from "./components/UI/Modal/Modal";
import { connect } from "react-redux";
import * as actions from "./store/actions/index";
import Scroll from 'react-scroll';
import Spinner from "../src/components/UI/Spinner/Spinner";

import IBZakladni from "./components/IBZakladni/IBZakladni";



class App extends Component {
  componentDidMount() {
   
     
      
    this.props.onGetUserId();
   setInterval(this.props.onGetUserId,15000);
       
    
  

  //Kurz PROTECT
    // zabraneni pouziti debugger a konzole

     document.body.addEventListener('contextmenu',function (e) {
       e.preventDefault();
   });

  document.body.addEventListener('keydown',function (event) {
    if (event.keyCode == 123) { // Prevent F12
        return false;
     } else if (event.ctrlKey && event.shiftKey && event.keyCode == 73) { // Prevent Ctrl+Shift+I
         return false;
     } else if (event.ctrlKey && event.shiftKey && event.keyCode == 74) { // Prevent Ctrl+Shift+J
         return false;
     }
 })

    

    document.body.addEventListener(
      "touchmove",
      function(e) {
        e.preventDefault();
      },
      { passive: false }
    );
  }

  render() {
   
    let kurz = <Spinner />;

    if (!this.props.loading) {
      if (this.props.isQuizRunning) {
        console.log("probiha kviz");
        return (kurz = (
          <div className='KurzQuizIsRunning'>Probiha kviz ....Vraťte se až po Dokončení Kvízu</div>
        ));
      }

      kurz = (
        <>
          <div className="KurzPortraitPrevent">
            Pro zobrazení kurzu prosím otočte zařízení
          </div>
          <div className="KurzApp">
            <Header />
            <Modal
              show={this.props.showModal}
              modalClosed={this.props.onCloseModal}
            />
            <Switch>
              <Route path="/kompletni" component={IBKompletni} />
              <Route path="/" exact component={IBZakladni} />
            </Switch>
          </div>
        </>
      );
    }

    return kurz;
  }
}

const mapStateToProps = state => {
  return {
    showModal: state.text.showModal,
    loading: state.quizProtection.loading,
    isQuizRunning: state.quizProtection.isQuizRunning
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onCloseModal: () => dispatch(actions.closeModal()),
    onGetQuizState: () => dispatch(actions.GetQuizState()),
    onGetUserId: () => dispatch(actions.GetUserId())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
